import React from 'react';
import { callejeritosImages } from '../../helpers/callejeritosImages';

export const IsLoading = () => {
    return (<img src={ callejeritosImages('./loader.gif').default } alt="Loading..." width={ 90 } height={ 90 } className="mx-auto"/>)
}
